import { useCallback } from 'react';

import { useRequirementState } from './useRequirementState';

export const useRequirementMinCountState = () => {
  const {
    requirement: { minMatch: requirementMinCount },
    setRequirement,
  } = useRequirementState();
  const setRequirementMinCount = useCallback(
    (newMinCount?: number) =>
      setRequirement((requirement) => ({ ...requirement, minMatch: newMinCount })),
    [setRequirement],
  );
  return {
    requirementMinCount,
    setRequirementMinCount,
  };
};
